import axios from "axios";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const BACKEND_URL = "http://103.171.180.218:9000";

// Set axios baseURL for local dev; Netlify proxy handles it in production
if (isLocalhost) {
  axios.defaults.baseURL = BACKEND_URL;
}

/**
 * Use this for ALL image/file <img src> and background-image URLs.
 * Locally: prefixes with backend IP
 * On Netlify: uses relative path (proxy in netlify.toml handles it)
 *
 * Example: imgURL(`/Faculty/${item.FImg}`)
 */
export const imgURL = (path) => {
  if (isLocalhost) {
    return `${BACKEND_URL}${path}`;
  }
  return path;
};

export default axios;
